interface ReportToastProps {
  onClose(): void;
}

export default function ReportToast({ onClose }: ReportToastProps) {
  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: dont worry, its fine
    // biome-ignore lint/a11y/useKeyWithClickEvents: dont worry, its fine
    // biome-ignore lint/a11y/noNoninteractiveElementInteractions: legacy
    <div
      className="max-w-77.5 cursor-pointer rounded-[5px] border border-maize bg-rich-black px-3 py-2.5 shadow-0-0-10 shadow-maize"
      onClick={onClose}
    >
      <h2 className="text-20/[1em] text-maize uppercase">Review reported</h2>
      <p className="mt-1 text-12/[1.4em] text-maize">
        We’ve notified the Review police. They’ll investigate this asap and may
        contact you.
      </p>
    </div>
  );
}
